import request from "tools/request"

/**
 * Fetches the aggregated underwriter dashboard payload.
 * @param {('TODAY'|'WEEK'|'MONTH')} range
 */
export const getUnderwriterDashboard = (range = 'WEEK') => async () => {
    const res = await request(
        'underwriter/dashboard',
        'GET',
        null,
        false,
        {},
        { range }
    )
    return res
}

/**
 * Fetches the current client's underwriting SLA settings.
 * Uses the x-client-Id header attached by the request wrapper — no UUID needed.
 */
export const getUnderwritingSettings = () => async () => {
    const res = await request('underwriting-settings', 'GET')
    return res
}

/**
 * Updates the underwriting SLA settings for the current client.
 * @param {{ decisionSlaHours: number }} payload
 */
export const updateUnderwritingSettings = (payload) => async () => {
    const res = await request('underwriting-settings', 'PATCH', payload)
    return res
}
